import { create } from 'zustand'

export type ConfirmOptions = {
  title: string
  description?: string
  /** 省略時は destructive なら「削除」、それ以外は「OK」 */
  confirmLabel?: string
  /** 前後の内容を分かりやすくする画像（AuthImage で署名付きで読む） */
  imageSrc?: string
  /** 削除など取り消せない操作。確定ボタンを赤くする */
  destructive?: boolean
}

type ConfirmDialogState = {
  options: ConfirmOptions | null
  isOpen: boolean
  resolve: ((ok: boolean) => void) | null
  open: (options: ConfirmOptions) => Promise<boolean>
  settle: (ok: boolean) => void
}

export const useConfirmDialogStore = create<ConfirmDialogState>()((set, get) => ({
  options: null,
  isOpen: false,
  resolve: null,
  open: (options) =>
    new Promise<boolean>((resolve) => {
      // 前の確認が開いたままなら取り消し扱いで閉じる。待っている側を宙に浮かせない
      get().resolve?.(false)
      set({ options, isOpen: true, resolve })
    }),
  // 閉じるアニメーションの間も文言を出し続けたいので options は残す
  settle: (ok) => {
    get().resolve?.(ok)
    set({ isOpen: false, resolve: null })
  },
}))
